import RegNext from '@/components/RegAndForgot/RegNext';
export default function RegisterNext() {
    const element = (
        <>
            <RegNext />
        </>
    );
    return element;
}
